/**
 * Description: matter接口
 * Author: lixm
 * Date: 2019-06-27
 */

export const matterApiMap = {
  //获取警种列表
  pccs:'/matters/v1/pccs',
  // 获取警种及分组列表
  pccGroups: '/matters/v1/pcc-groups',
  // 获取分页事项列表
  matterPage:'/matters/v1/page',
  //返回事项列表分组
  matterPageGroup:'/matters/v1/page-group',
  //根据类型查询分组列表
  getGroupByTypeId:'/matters/v1/groups',
  //获取申请下拉列表
  getSelDept:'/matters/v1/depts',
  //根据材料ID和材料类型获取样表，及表格数据
  getManifestById:'/matters/v1/manifests',
  //获取样表，及表格数据
  downloadFests:'/matters/v1/manifestsdownload/',
  //更新下载次数
  downloadCount:'/matters/v1/downloads',
  //获取事项详情
  getMattersEtDetail:'/matters/v1',
  //获取事项详情 （带流程图version）
  getMattersInfo:'/matters/hubeigat',
  //获取事项详情
  getMatterstDetailByNumDept:'/matters/v1/info/',
  //获取材料列表
  getManifests:'/matters/v1/manifestslst',
  //根据部门ID获取材料列表
  getDeptAddressById:'/matters/v1/address',
  //获取单个材料
  getManifest:'/matters/v1/manifest/',
  //更新热点事项
  updateMatterHot:'/matters/v1/mathot/',
  //服务事项数以及子事项跟可在现办理事项数
  mateCount:'/matters/v1/count',


}

